<template>
  <v-hover>
    <template v-slot="{ hover }">
      <v-card :elevation="hover ? 6 : 4">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            <v-icon color="white">mdi-content-duplicate</v-icon>
            Articoli Residui
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-2"
                @click="aggiungiArtRes"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Articolo Residuo</span>
          </v-tooltip>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setArticoloResiduo" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-data-table :headers="headers_art_res" :items="items_art_res">
              <!-- Bottone di stampa -->
              <template v-slot:[`item.stampa`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickStampaEtichettaRes(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-printer </v-icon>
                    </v-btn>
                  </template>
                  <span>Stampa</span>
                </v-tooltip>
              </template>

              <!-- Colonna della quantità -->
              <template v-slot:[`item.quantita`]="{ item }">
                <v-text-field
                  single-line
                  style="display: inline-block; margin-left: 5px; width: 50px"
                  type="number"
                  v-model="item.quantita"
                />
              </template>

              <!-- Bottone di eliminazione -->
              <template v-slot:[`item.elimina`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="eliminaArtRes(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                  <span>Elimina</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <!-- DIALOG cerca articolo -->
        <v-dialog v-model="dialog_agg_art" color="indigo" dense width="60%">
          <v-card>
            <v-toolbar color="indigo" dense>
              <v-toolbar-title class="white--text">
                Aggiungi Articolo
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="dialog_agg_art = false"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-toolbar>

            <v-container>
              <v-row justify="center" align="center" class="mt-1 mb-2">
                <v-col cols="5">
                  <v-text-field
                    hide-details
                    dense
                    v-model="cod_articolo_sel"
                    label="Cerca per Cod. Articolo"
                    @keydown.enter="getArticoli"
                  />
                </v-col>
                <v-col cols="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="getArticoli"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-magnify </v-icon>
                      </v-btn>
                    </template>
                    <span>Salva</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers_lista_art"
                :items="lista_articoli"
              >
                <template v-slot:[`item.seleziona`]="{ item }">
                  <v-btn @click="selezionaArtRes(item)" small>
                    <v-icon color="primary"> mdi-dolly </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-container>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_stampa" width="500px">
          <v-card>
            <v-toolbar color="indigo" dense>
              <v-toolbar-title class="white--text">
                Stampa Etichette
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <!-- Bottone di salvataggio -->
              <v-tooltip>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="stampaEtichettaRes"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="success">mdi-printer</v-icon>
                  </v-btn>
                </template>
                <span>Invia</span>
              </v-tooltip>

              <v-spacer></v-spacer>

              <!-- Bottone di chiusura -->
              <v-tooltip>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="chiudiDialogStampe"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-toolbar>
            <v-card-text class="mt-5">
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <span style="font-size: 18px">
                      Inserire la quantità di etichette da stampare e la
                      quantità di materiale da registrare a magazzino.
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      class="centered-input"
                      dense
                      hide-details
                      outlined
                      label="Q.tà Etichette"
                      style="border-radius: 0px"
                      v-model="quantita_etichette"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      class="centered-input"
                      dense
                      hide-details
                      label="Q.tà a Magazzino"
                      outlined
                      style="border-radius: 0px"
                      v-model="quantita_registrazione"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />

        <!-- Overlay -->
        <v-overlay :value="overlay" style="z-index: 999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </template>
  </v-hover>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class ArticoloRes {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "cod_articolo", default_val: "" },
      { nome: "des_articolo", default_val: "" },
      { nome: "id_articolo_alternativo", default_val: -1 },
      { nome: "id_articolo", default_val: -1 },
      { nome: "id_alternativo", default_val: -1 },
      { nome: "id_um", default_val: null },
      { nome: "quantita", default_val: 0 },
      { nome: "articolo_residuo", default_val: 1 },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  name: "ArticoloResiduo",
  components: {
    SnackbarQV,
  },
  props: {
    articolo_prop: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      articolo_sel: null,
      articolo_res_sel: new ArticoloRes(),
      cod_articolo_sel: null,
      quantita_etichette: 1,
      quantita_registrazione: 1,

      // Modal
      dialog_agg_art: false,
      dialog_stampa: false,
      overlay: false,

      // Array
      headers_art_res: [
        { text: "Stampa Etichette", value: "stampa", width: "150px" },
        { text: "Codice", value: "cod_articolo" },
        { text: "Descrizione", value: "des_articolo" },
        { text: "Elimina", value: "elimina", width: "150px" },
      ],
      headers_lista_art: [
        { text: "Seleziona", value: "seleziona" },
        { text: "Cod. Articolo", value: "cod_articolo" },
        { text: "Des. Articolo ", value: "des_articolo" },
      ],
      items_art_res: [],
      lista_articoli: [],
    };
  },
  computed: {},
  watch: {
    articolo_prop: {
      immediate: true,
      handler() {
        this.articolo_sel = this.articolo_prop;
      },
    },
  },
  methods: {
    aggiungiArtRes() {
      this.dialog_agg_art = true;
      this.lista_articoli = new Array();
    },
    clickStampaEtichettaRes(arg) {
      this.dialog_stampa = true;
      this.articolo_res_sel = new ArticoloRes(arg);
      this.quantita_etichette = 1;
      this.quantita_registrazione = 1;
    },
    eliminaArtRes(item) {
      item.validita = 0;
      this.setArticoloResiduo();
    },
    chiudiDialogStampe() {
      this.dialog_stampa = false;
    },
    getArticoli() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.cod_articolo_sel,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.lista_articoli = res.data.lista;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getArticoloRes() {
      this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoloalternativo",
          token: localStorage.getItem("user_token"),
          filter: " AND articolo_residuo = 1 ",
          id_articolo: this.articolo_sel.id_articolo,
        },
      };
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_art_res = res.data.result;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    selezionaArtRes(item) {
      let check_id_articolo = true;
      let check_id_articolo_principale = true;

      /* Controllo che l'articolo da aggiungere
       * non corrisponda a quello principale. */
      if (item.id_articolo == this.articolo_sel.id_articolo) {
        check_id_articolo_principale = false;
      }

      if (check_id_articolo_principale == false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "L'articolo principale non può essere residuo di sé stesso."
        );
        return;
      }

      /* Controllo che l'articolo da
       * aggiungere non sia già presente. */
      this.items_art_res.forEach((elem) => {
        if (elem.id_alternativo == item.id_articolo) {
          check_id_articolo = false;
        }
      });

      if (check_id_articolo == false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Articolo già presente nella lista."
        );
        return;
      }

      let art_tmp;
      art_tmp = new ArticoloRes();
      art_tmp.id_articolo = this.articolo_sel.id_articolo;
      art_tmp.cod_articolo = item.cod_articolo;
      art_tmp.des_articolo = item.des_articolo;
      art_tmp.id_alternativo = item.id_articolo;
      this.items_art_res.unshift(art_tmp);
      this.dialog_agg_art = false;
      this.cod_articolo_sel = null;
    },
    setArticoloResiduo() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticoloalternativo",
          token: localStorage.getItem("user_token"),
          articolo_alternativo: this.items_art_res,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Dati salvati correttamente."
            );
            this.getArticoloRes();
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    stampaEtichettaRes() {
      /* Devo generare il PDF dell'etichetta dell'articolo
       * che è passato in argomento alla funzione. */

      // Controllo che la quantità sia positiva.
      if (
        this.quantita_registrazione == null ||
        this.quantita_registrazione === "" ||
        this.quantita_registrazione <= 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Dichiarare una quantità maggiore di 0 per registrare."
        );

        return;
      }

      const art_res_request = {
        id_magazzino_movimenti: -1,
        data: moment().format("YYYY-MM-DD HH:mm:ss"),
        id_articolo: this.articolo_res_sel.id_alternativo,
        cod_articolo: this.articolo_res_sel.cod_articolo,
        des_articolo: this.articolo_res_sel.des_articolo,
        id_causale: "",
        id_magazzino: -99,
        id_causale_magazzino: 1,
        quantita: this.quantita_registrazione,
        id_um: this.articolo_res_sel.id_um,
        flag_export: 0,
        stato_controllo: 0,
        numero_seriale: -1,
        validita: 1,
      };

      /* Mando al BE la request. Il seriale con tipo REGISTRAZIONE_ARTICOLO_RESIDUO
       * viene incrementato quando viene generato il PDF nel contesto di questa chiamata.
       * La chiamata genera anche un serialem, ma lo genera a BE e non devo passarlo in
       * questa sede: fa tutto la logica C# sul server. */
      const arr_tmp = [
        {
          parametro: "@quantita_etichette",
          valore: this.quantita_etichette,
        },
        {
          parametro: "@id_articolo_residuo",
          valore: this.articolo_res_sel.id_alternativo,
        },
        {
          parametro: "@nominativo_persona",
          valore: localStorage.nominativo,
        },
        {
          parametro: "@quantita",
          valore: this.quantita_registrazione,
        },
      ];

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "registraestampaartres",
          token: localStorage.user_token,
          quantita_etichette: this.quantita_etichette,
          articolo: [art_res_request],
          dati_report: {
            cod_report: "ReportArtRes",
            parametri: arr_tmp,
          },
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (
              "tipo_messaggio" in res.data &&
              "query_messaggio" in res.data &&
              res.data.tipo_messaggio == 1
            ) {
              this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
            }

            const byteCharacters = atob(res.data.result);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, "_blank");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Invio di stampa non riuscito."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          if (
            "tipo_messaggio" in err.response.data &&
            "query_messaggio" in err.response.data &&
            err.response.data.tipo_messaggio == 2
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              err.response.data.query_messaggio
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Invio di stampa non riuscito."
            );
          }
        });
    },
  },
  created() {},
  mounted() {
    this.getArticoloRes();
  },
};
</script>
<style scoped>
</style>